import Lenis from "lenis";

/* Inertial scrolling for the whole site, in the spirit of offmenu.design's
   ScrollSmoother (smooth: 1.2). Lenis keeps the window as the scroller, so
   the home page's sticky orbit stage and its scroll-driven loop keep
   working unchanged. Touch scrolling stays native. It is not started for
   people who prefer reduced motion. */

let lenis = null;

export function getLenis() {
  return lenis;
}

export function startSmoothScroll() {
  if (lenis || typeof window === "undefined") return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  lenis = new Lenis({
    lerp: 0.08,
    anchors: true,
    stopInertiaOnNavigate: true,
    autoRaf: true,
  });
}

/* Cancels any inertia before a route change, so Gatsby's own jump to the
   top (or to a restored position) is not fought by a running glide. Lenis's
   stop() is not used here: it clips the page's overflow, which would block
   that jump. */
export function pauseSmoothScroll() {
  lenis?.reset();
}

/* Re-reads the new page's height and position after a route change. */
export function resumeSmoothScroll() {
  lenis?.resize();
}
